import { Component, Input } from '@angular/core';
import { NgbActiveModal }   from '@ng-bootstrap/ng-bootstrap';

import { BookingsApiKeysModel } from './typings/bookings.api-keys';

@Component({
  selector   : 'wor-bookings-api-secret-key',
  template: require('./bookings.api-secret-key.component.html')
})
export class BookingsApiSecretKeyComponent {
  @Input() keys : BookingsApiKeysModel;

  constructor (
    public activeModal: NgbActiveModal
  ) {}
}
